import { useParams } from "react-router-dom";

import { BankStatementUpload } from "@/jenesys-types/jenesys-entities/config";

import { CrudEdit } from "@/components/common/crud/CrudEdit/CrudEdit";
import { ReconStatementUploadEditFormWrapper } from "@/components/features/reconciliation/ReconStatementUploadEditForm";

export const ReconStatementUploadEditRoute = () => {
  const { clientId, reconciliationId, bankStatementUploadsId } = useParams();
  return (
    <CrudEdit<BankStatementUpload>
      pathParams={{
        clientId,
        accountId: reconciliationId,
        bankStatementUploadsId
      }}
      form={ReconStatementUploadEditFormWrapper}
      breadcrumbTitle="Extracted Statement Details"
    />
  );
};
